import { render, staticRenderFns } from "./CombineTrucks.vue?vue&type=template&id=0ad0e28a"
import script from "./CombineTrucks.vue?vue&type=script&lang=ts"
export * from "./CombineTrucks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports